import styled from 'styled-components';
import { media } from '@app/styles/themes/constants';

export const ReferencesWrapper = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: start;
  flex-wrap: nowrap;

  margin-top: 1.5rem;
  padding: 12px 24px;
  background: #ffffff;
  border-top: 1px solid #eef2f2;

  @media only screen and ${media.sm} {
    align-items: center;
  }

  /* Tablet/desktop: footer cố định ở đáy viewport. Mobile thì nằm cuối nội dung — footer wrap
     nhiều dòng, ghim lại sẽ che ~1/5 màn hình và đè lên nội dung. */
  @media only screen and ${media.md} {
    position: sticky;
    bottom: 0;
    z-index: 5;
  }

  @media only screen and ${media.xl} {
    flex-direction: row;
    justify-content: space-between;
  }
`;

export const Text = styled.span`
  display: flex;
  align-items: center;
  white-space: pre-wrap;
  flex-wrap: wrap;
  margin-bottom: 1rem;

  @media only screen and ${media.xl} {
    margin-bottom: 0;
  }
`;

export const Icons = styled.div`
  margin-left: -0.3rem;
  margin-right: -0.3rem;
  display: flex;
  flex-wrap: nowrap;

  svg {
    font-size: 1.5rem;
    margin-left: 0.3rem;
    margin-right: 0.3rem;
  }
`;
